import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, ExternalLink, Star } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { appLinks } from '../data';
const categories = ['All', ...Array.from(new Set(appLinks.map(a => a.category).filter(Boolean) as string[]))];
export function AppsPage() {
  const [query, setQuery] = useState('');
  const [cat, setCat] = useState('All');
  const [favs, setFavs] = useState<Record<string, boolean>>({
    Encompass: true,
    Salesforce: true
  });
  const filtered = appLinks.filter(a => {
    const matchesQuery = a.label.toLowerCase().includes(query.toLowerCase());
    const matchesCat = cat === 'All' || a.category === cat;
    return matchesQuery && matchesCat;
  });
  return <>
      <PageHeader title="Apps" subtitle="Single sign-on access to every tool you use." data-id="element-376" />

      <div className="flex flex-col sm:flex-row gap-3 mb-6" data-id="element-377">
        <div className="relative flex-1 max-w-md" data-id="element-378">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-navy-400" data-id="element-379" />
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search apps…" className="w-full pl-11 pr-4 py-2.5 rounded-full bg-white border border-navy-100 focus:border-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400/30 text-sm text-navy-900" data-id="element-380" />
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-381">
          {categories.map(c => <button key={c} onClick={() => setCat(c)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${cat === c ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-382">
              {c}
            </button>)}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-383">
        {filtered.map((app, i) => <motion.div key={app.label} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.03
      }} className="relative bg-white rounded-xl border border-navy-100 p-5 hover:shadow-md hover:border-gold-400 transition-all group" data-id="element-384">
            <button onClick={() => setFavs(f => ({
          ...f,
          [app.label]: !f[app.label]
        }))} className="absolute top-3 right-3 text-navy-300 hover:text-gold-500" aria-label="Favorite" data-id="element-385">
              <Star className={`w-4 h-4 ${favs[app.label] ? 'fill-gold-500 text-gold-500' : ''}`} data-id="element-386" />
            </button>
            <span className={`w-14 h-14 rounded-xl ${app.color} text-white font-bold flex items-center justify-center mb-3 group-hover:scale-105 transition-transform`} data-id="element-387">
              {app.initials}
            </span>
            <p className="font-bold text-navy-900" data-id="element-388">{app.label}</p>
            <p className="text-xs text-navy-400 mb-3" data-id="element-389">{app.description}</p>
            <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-600" data-id="element-390">
              Launch <ExternalLink className="w-3 h-3" data-id="element-391" />
            </span>
          </motion.div>)}
      </div>
    </>;
}